import { WooCommerceCheckoutResponse } from '../../../core/interfaces/woo-commerce/api/checkout/checkout-api.interface';

export class AddOrderAction {
  static readonly type = '[Orders] Add item';

  constructor(public payload: WooCommerceCheckoutResponse) {}
}
